<template>
	<div class="batch">
		<p class="batch__info">
			블라인드 사유를 최대 2개까지 선택할 수 있습니다.
		</p>
		<div class="batch__select-box">
			<selector
				v-model="causeIds[0]"
				:option-list="blindCauseList"
				class="batch__select-box__selector"
				@input="causeChange"
			/>
			<selector
				v-model="causeIds[1]"
				:option-list="blindCauseList2"
				:disabled="!causeIds[0]"
				class="batch__select-box__selector"
			/>
		</div>
		<div class="btn-wrap-main">
			<button class="btn-main" @click="cancel">취소</button>
			<button class="btn-main blue" @click="batch">일괄처리</button>
		</div>
	</div>
</template>
<script>
	import compact from 'lodash/compact';
	import { mapState } from 'vuex';
	import Selector from '@/components/Selector';

	export default {
		name: 'BatchBlind',
		components: {
			Selector,
		},
		data() {
			return {
				causeIds: [null, null],
			};
		},
		computed: {
			...mapState({
				causeList: state => state.notice.causeList,
				params: state => state.modal.params,
			}),
			blindCauseList() {
				return [
					{ value: null, name: '사유를 선택하세요' },
					...(this.causeList || []),
				];
			},
			blindCauseList2() {
				return this.blindCauseList.filter(
					({ value }) =>
						this.causeIds[0] === null || value !== this.causeIds[0]
				);
			},
		},
		created() {
			if (!this.causeList) {
				this.$store.dispatch('notice/init');
			}
		},
		methods: {
			causeChange() {
				this.causeIds[1] = null;
			},
			cancel() {
				this.$store.commit('modal/toggleModal', {});
			},
			async batch() {
				try {
					if (!this.causeIds[0]) {
						alert('사유를 선택하세요.');
						return;
					}
					const params = {
						idReviewComments: this.params.idReviewComments,
						reviewCommentState: 'B',
						causeIds: compact(this.causeIds),
					};
					await this.$axiosAdmin2.put('/v3/api/review/state', params);
					alert('블라인드가 일괄처리 되었습니다.');
					this.params.cb();
					this.cancel();
				} catch (err) {
					console.error(err);
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.batch__info {
		margin: 12px 0;
	}

	.batch__select-box {
		display: flex;
		width: 100%;
		justify-content: space-between;
	}

	.batch__select-box__selector {
		width: 274px;
	}
</style>
